import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import DiagnosticStates from 'src/Components/AdminComponents/DiagnosticStates';
import PieChartGraph from 'src/Components/AdminComponents/Graphs/PieChartGraph';
import ProgressGraph from 'src/Components/AdminComponents/Graphs/ProgressGraph';
import httpRequest from 'src/helpers/httpRequest';
import iconBiomarker from "src/assets/images/admin-dashboard/biomarker-icon.png";
import iconCategory from "src/assets/images/admin-dashboard/category-icon.png";
import iconOrder from "src/assets/images/admin-dashboard/purchase-order.png";
import iconRevenue from "src/assets/images/admin-dashboard/revenue-icon.png";
import { CircularProgress } from '@mui/material';
import HomecareStates from 'src/Components/AdminComponents/HomecareStates';
import { CURRENCY } from 'src/lib/constans';

type tabTypes = "Diagnostic" | "Pharmacy" | "At Home Services";
interface ICategories {
    id: string;
    name: string;
    totalCount: number;
    [key:string]:any
};
const Analytics: React.FC = () => {
    const tabList: tabTypes[] = ["Diagnostic", "Pharmacy", "At Home Services"];
    const [selectedTab, setSelectedTab] = useState<tabTypes>("Diagnostic");

    const [topSelling, setTopSelling] = useState<{ loader: boolean; allCategories: ICategories[], total: any }>({
        loader: false,
        allCategories: [],
        total: 0,
    });
    const fetchTopSellingCategories = async () => {
        setTopSelling(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<any>({ path: "/diagnostic-order/top/selling-categories" });
        if (res) {
            setTopSelling(prev => ({ ...prev, allCategories: res?.data || [],total:res?.totalProducts }));
        } else {
            toast(err, { type: "error" });
        }
        setTopSelling(prev => ({ ...prev, loader: false }));
    };

    const [pharmaAnalytics, setPharmaAnalytics] = useState<{ loader: boolean; data: { label: string; key: string; count: number; images: string; }[]; }>({
        loader: false,
        data: [
            { label: "Total Category", key: "totalCategories", count: 0, images: iconBiomarker },
            { label: "Total Brands", key: "totalBrands", count: 0, images: iconCategory },
            { label: "Total Inventory", key: "totalPharmacyProducts", count: 0, images: iconOrder },
            { label: "Total Orders", key: "totalOrders", count: 0, images: iconOrder },
            { label: "Total Revenue", key: "totalRevenue", count: 0, images: iconRevenue },
        ],
    });
    const fetchPharmaAnalytics = async () => {
        setPharmaAnalytics(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<{ data: { totalCategories: number; totalBrands: number; totalPharmacyProducts: number; totalOrders: number; totalRevenue: number; } }>({ path: "/pharma-order/admin/analytics" });
        if (res) {
            Object.entries(res.data).map(([key, value]) => {
                setPharmaAnalytics(prev => ({
                    ...prev,
                    data: prev.data.map(v => v?.key === key ? { ...v, count: value } : v)
                }));
            });
        } else {
            toast(err, { type: "error" });
        }
        setPharmaAnalytics(prev => ({ ...prev, loader: false }));
    };

    const [pharmaSelling, setPharmaSelling] = useState<{ loader: boolean; allCategories: ICategories[] }>({
        loader: false,
        allCategories: [],
    });
    const fetchTopSellingPharmaCategories = async () => {
        setPharmaSelling(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<{ data: ICategories[] }>({ path: "/pharma-order/top/selling-categories" });
        if (res) {
            setPharmaSelling(prev => ({ ...prev, allCategories: res?.data || [] }));
        } else {
            toast(err, { type: "error" });
        }
        setPharmaSelling(prev => ({ ...prev, loader: false }));
    };

    const [pharmaCategories, setPharmaCategories] = useState<{ loader: boolean; totalProducts: number; allCategories: { mainCategoryName: string; productCount: number; }[] }>({
        loader: false,
        totalProducts: 0,
        allCategories: [],
    });
    const fetchPharmaCategories = async () => {
        setPharmaCategories(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<{ categoriesWithCounts: { mainCategoryName: string; productCount: number; }[]; totalProducts: number; }>({ path: "/pharma-inventory/get-category-count" });
        if (res) {

            setPharmaCategories(prev => ({ ...prev, totalProducts: res?.totalProducts, allCategories: res?.categoriesWithCounts || [] }));
        } else {
            toast(err, { type: "error" });
        }
        setPharmaCategories(prev => ({ ...prev, loader: false }));
    };

    const [homecareCategories, setHomecareCategories] = useState<{ loader: boolean; totalProducts: number; allCategories: { CategoryName: string; productCount: number; }[] }>({
        loader: false,
        totalProducts: 0,
        allCategories: [],
    });
    const fetchHomecareCategories = async () => {
        setHomecareCategories(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<{ result: { categoriesWithCounts: { CategoryName: string; productCount: number; }[]; }; totalCount: number; }>({ path: "/home-care-services/get-category-count" });
        if (res) {
            setHomecareCategories(prev => ({ ...prev, totalProducts: res?.totalCount, allCategories: res?.result?.categoriesWithCounts || [] }));
        } else {
            toast(err, { type: "error" });
        }
        setHomecareCategories(prev => ({ ...prev, loader: false }));
    };

    const [homecareSelling, setHomecareSelling] = useState<{ loader: boolean; allCategories: ICategories[] }>({
        loader: false,
        allCategories: [],
    });
    const fetchTopSellingHomecareCategories = async () => {
        setHomecareSelling(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<{ data: ICategories[] }>({ path: "/home-care-order/top/selling-categories" });
        if (res) {
            setHomecareSelling(prev => ({ ...prev, allCategories: res?.data || [] }));
        } else {
            toast(err, { type: "error" });
        }
        setHomecareSelling(prev => ({ ...prev, loader: false }));
    };

    useEffect(() => {
        if (selectedTab === "Diagnostic") {
            fetchTopSellingCategories();
        } else if (selectedTab === "Pharmacy") {
            fetchPharmaAnalytics();
            fetchTopSellingPharmaCategories();
            fetchPharmaCategories();
        } else {
            fetchHomecareCategories();
            fetchTopSellingHomecareCategories();
        }
    }, [selectedTab]);
    console.log(topSelling, "Aaaaaaaaaaaaaaaaaaaaaa")
    return (
        <div className="p-4">
            <div className='products-tabs-btn mb-4'>
                {tabList.map((item: tabTypes) => (
                    <button
                        key={item}
                        className={`relative font-size-15px font-Poppins-Medium ${selectedTab === item && 'active'}`}
                        onClick={() => setSelectedTab(item)}
                    >
                        {item}
                    </button>
                ))}
            </div>

            {selectedTab === "Diagnostic" ?
                <>
                    <DiagnosticStates />
                    <div className="parent-box parent-box-graph-height">
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                            <ProgressGraph
                                data={topSelling.allCategories?.slice(0, 5)?.map(v => ({ label: v?.name, count: v?.totalCount }))}
                                totalCount={topSelling.allCategories?.slice(0, 5)?.reduce((prev, current) => { return prev + current?.totalCount }, 0)}
                                loader={topSelling.loader}
                                heading={"Top Selling Test Categories"}
                            />
                            <PieChartGraph
                                data={topSelling.allCategories?.map(v => ({ label: v?.name, count: v?.totalCount }))}
                                // totalCount={topSelling.allCategories?.reduce((prev, current) => { return prev + current?.totalCount }, 0)}
                                totalCount={topSelling.total}
                                loader={topSelling.loader}
                                circleTitle={"Categories"}
                                heading={"Top Selling Test Categories"}
                            />
                        </div>
                    </div>
                </>
                : selectedTab === "Pharmacy" ?
                    <>
                        <div className='parent-box'>
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
                                {pharmaAnalytics.data.map(item => (
                                    <div key={item.key} className="dashboard-sm-box">
                                        <div className="dashboard-inner-box w-[80%] text-center">
                                            <img className='admin-dashboard-img' src={item?.images} alt="biomarker-icon" />
                                            <p className="font-Poppins-Medium font-size-20px">
                                                {item?.label || ""}
                                            </p>
                                            {pharmaAnalytics.loader
                                                ?
                                                <CircularProgress size={20} className="theme-color-green" />
                                                :
                                                <p className="font-Poppins-SemiBold font-size-26px theme-color-green">
                                                    {`${item.key === "totalRevenue" ? CURRENCY : ""}${item.count || "-"}`}
                                                </p>
                                            }
                                        </div>
                                    </div>
                                ))
                                }
                            </div>
                        </div>
                        <div className="parent-box parent-box-graph-height">
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                                <ProgressGraph
                                    data={pharmaSelling.allCategories?.slice(0, 5)?.map(v => ({ label: v?.name, count: v?.totalCount }))}
                                    totalCount={pharmaSelling.allCategories?.slice(0, 5)?.reduce((prev, current) => { return prev + current?.totalCount }, 0)}
                                    loader={pharmaSelling.loader}
                                    heading={"Top Selling Pharma Categories"}
                                />
                                <PieChartGraph
                                    data={pharmaCategories.allCategories?.map(v => ({ label: v?.mainCategoryName, count: v?.productCount }))}
                                    totalCount={pharmaCategories.totalProducts}
                                    loader={pharmaCategories.loader}
                                    circleTitle={"Products"}
                                    heading={"Pharma Categories"}
                                />
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <HomecareStates />
                        <div className="parent-box parent-box-graph-height">
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                                <ProgressGraph
                                    data={homecareSelling.allCategories?.slice(0, 5)?.map(v => ({ label: v?.name, count: v?.totalCount }))}
                                    totalCount={homecareSelling.allCategories?.slice(0, 5)?.reduce((prev, current) => { return prev + current?.totalCount }, 0)}
                                    loader={homecareSelling.loader}
                                    heading={"Top Selling Homecare Categories"}
                                />
                                <PieChartGraph
                                    data={homecareCategories.allCategories?.map(v => ({ label: v?.CategoryName, count: v?.productCount }))}
                                    totalCount={homecareCategories.totalProducts}
                                    loader={homecareCategories.loader}
                                    circleTitle={"Products"}
                                    heading={"Homecare Categories"}
                                />
                            </div>
                        </div>
                    </>
            }
        </div>
    );
};

export default Analytics;